<template>
	<p :class="classes"><slot /></p>
</template>

<script>
export default {
	props: {
		loading: {
			default: true,
			type: Boolean,
		},
		loadingClass: {
			type: [String, Object, Array],
			default: '',
		},
	},

	computed: {
		classes() {
			return [this.loading ? this.loadingClass : '', this.loading ? 'animate-shimmer !text-transparent' : '']
		},
	},
}
</script>
